import Vue from 'vue'
// 钱的数字
Vue.filter('numFormat', function (num) {
  let string = new Number(num).toLocaleString() // eslint-disable-line
  let c = 0
  let arr = []
  if (string.indexOf('.') !== -1) {
    arr = string.split('.')
    c = arr[0].replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + '.' + arr[1].substring(0, 2)
  } else {
    c = string.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
  }
  return c
})



// WEBPACK FOOTER //
// ./src/filter/filter.js